import {Interceptor} from '@jobseeker/common-core/components';
import {NotFound} from '@components';
import {metaInfo} from '@configs';
import {getConfigByApp} from '@utils';
import {usePageLoad} from '@hooks';
import {NOTFOUND} from '@constants';
import {isCSR} from '@jobseeker/lotus/utils';
import {SeoIntrup} from '@layouts/SeoLayout';

const NotFoundPage = () => {
  const metaData = getConfigByApp(metaInfo, NOTFOUND, false, '404');
  const Domain = process.env.NEXT_PUBLIC_APP_DOMAIN;
  const titleText = `${Domain} - 404 Error Found`;

  usePageLoad(NOTFOUND);

  return (
    <Interceptor metaInfo={metaData['app'][NOTFOUND]}>
      {isCSR() && (
        <SeoIntrup
          title={titleText}
          pageNo={0}
          nextPage={false}
          type={NOTFOUND}
        />
      )}
      <NotFound />
    </Interceptor>
  );
};

export default NotFoundPage;
